var React = require('react');

function LogoThebreathingiq (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M110 29H66V121L110 77V29ZM68 159.872C68.0216 193.351 94.2047 220.484 126.5 220.484C135.78 220.484 144.556 218.243 152.351 214.255L166 227L185.5 214.97L169.73 200.695C179.216 189.914 185 175.573 185 159.83C185 126.821 159.567 99.9704 127.909 99.1945L68 159.872ZM134 168.352L143.965 177.372C145.893 172.229 147 166.233 147 159.83C147 140.728 137.15 125.243 125 125.243C112.85 125.243 103 140.728 103 159.83C103 178.932 112.85 194.418 125 194.418C126.757 194.418 128.466 194.094 130.103 193.482L115 179.38L134 168.352Z"}));
}

LogoThebreathingiq.defaultProps = {"width":"260","height":"260","viewBox":"0 0 260 260","fill":"none"};

module.exports = LogoThebreathingiq;

LogoThebreathingiq.default = LogoThebreathingiq;
